import axios from 'axios';

export const state = {
    carriers_available: [],
}

export const getters = {
    getCarriersAvailable: (state) => state.carriers_available,
}

export const actions = {
    async fetchCarriersAvailable({ commit }) {
        const response = await axios.get(`operation/carriers/available`);
        commit('SET_CARRIERS_AVIALABLE', response.data);
    },
}


export const mutations = {
    SET_CARRIERS_AVIALABLE: (state, result) =>{ 
        state.carriers_available = result;
        // state.carriers_available.unshift({value: 0, name: '---'});
    }
}